const headers = {
  name: "Purchases Invoice",
  navigate: {
    path: [
      {
        name: "Purchases",
        path: "/app/purchases/returns",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
